import React from 'react'
import { Cube } from '../geometries/Cube'

export const Window = ({ position, scale = [1, 1, 1], width, height }) => {
	return (
		<group position={position} scale={scale} receiveShadow>
			<Cube color='lightblue' position={[0, 75, 0]} size={[width, 150, height]} opacity={0.5} />
		</group>
	);
};
